export default class AvatarController {

  constructor(app, pageId) {
    this.app = app;
    this.pageId = pageId;
  }
  show(path) {
    const app = this.app;
    const pageId = this.pageId || path;

    //get model
    const model = this.getModel();

    app.populate(pageId, model);
    app.swapPage(pageId);
  }
  getModel() {
    const app = this.app;
    const userdata = app.userdata;
    const items = app.items;

    let coins = userdata.coins || 0;
    let fullVersion = userdata.fullVersion;
    let ownedItems = userdata.items || [];
    let avatar_current = userdata.avatar;
    //let avatar_facebook = userdata.avatar_facebook;
    let itemsAll = items.allItems.filter(i => i.type === "Avatar");
    let itemsModel = itemsAll.map((i) => {
      let owned = ownedItems.includes(i.name);
      if (i.cost === 0 || fullVersion == true) owned = true;
      return {
        name: i.name,
        icon: i.icon,
        url: i.url,
        title: i.title,
        owned: owned,
        locked: !owned
      };
    });
    // if (avatar_facebook) {
    //   itemsModel.unshift({
    //     name: "AvatarFacebook",
    //     icon: avatar_facebook,
    //     url: avatar_facebook,
    //     title: "Facebook",
    //     owned: true,
    //     locked: false
    //   });
    // }
    if (avatar_current) {
      itemsModel.unshift({
        name: "AvatarCurrent",
        icon: avatar_current,
        url: avatar_current,
        title: "Current",
        owned: true,
        locked: false
      });
    }



    let model = {
      coins: coins,
      items: itemsModel
    }
    return model;
  }
  selectAvatar(avatar) {
    const app = this.app;
    const userdata = app.userdata;

    userdata.avatar = avatar;
    app.navigate('Profile');
  }
  async avatarUpload(file) {
    const app = this.app;
    const userdata = app.userdata;

    let id = userdata.id;
    app.createNotification("Uploading...");
    try {
      let url = await app.accountJD.UploadAvatar(id, file);
      if (url) {
        app.userdata.avatar = url;
        app.navigate('Profile');
        app.createNotification("saved");
      } else {
        app.createNotification("upload failed");
      }
    } catch (error) {
      if(!error) error = {};
      const status = error.status || "";
      const message = error.message || "";
      app.createNotification("upload failed: " + status + " " + message);
    };
  }
}